import { render, staticRenderFns } from "./SavedProductDetails.vue?vue&type=template&id=53536d8a&scoped=true"
import script from "./SavedProductDetails.vue?vue&type=script&lang=js"
export * from "./SavedProductDetails.vue?vue&type=script&lang=js"
import style0 from "./SavedProductDetails.vue?vue&type=style&index=0&id=53536d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53536d8a",
  null
  
)

export default component.exports